var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('private-image-card',{attrs:{"user":_vm.user,"extendedUser":_vm.extendedUser,"showRoles":_vm.showRoles,"modalId":"edit-profile","edit-icon":_vm.editable,"eventName":"onClickEditProfile"},on:{"onClickEditProfile":_vm.onClickEditProfile}})}
var staticRenderFns = []

export { render, staticRenderFns }